<script setup>
import { Link } from '@inertiajs/vue3';

const props = defineProps({
    class: String,
    href: String,
    useInertia: {
        type: Boolean,
        default: true
    },
    target: {
        type: String,
        default: '_self'
    }
})

// Combine default classes with any custom classes passed in
const linkClasses = props.class || 'text-sm/6 font-semibold text-gray-900 transition-all duration-300 hover:text-green-700 ease-[cubic-bezier(.5,.85,.25,1.8)]';
</script>

<template>
    <Link :href="href" :target="target" :class="linkClasses" v-if="useInertia">
        <slot></slot>
    </Link>

    <a :href="href" :target="target" :class="linkClasses" v-else>
        <slot></slot>
    </a>
</template>